/* Shipping Packages Store */

import {fetchShippingPackages} from '@/api'

const state = {
    packages: []
}

const actions = {
    fetchShippingPackages (context, params) {
        return fetchShippingPackages(params).then(r => {
            context.commit('setShippingPackages', r.data)
        })
    }
}

const mutations = {
    setShippingPackages (state, payload) {
        state.packages = payload
    }
}

const getters = {
    getShippingPackages (state) {
        return state.packages
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
